document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("resultsSection").style.display = "none"; // Just in case
});

// Function to create a styled note item
function createNoteItem(note, type) {
  let li = document.createElement("li");
  li.textContent = note;
  li.classList.add("note-item", type);
  return li;
}

// ***************************************

// JS to handle question selection and form submission
var form = document.getElementById("myForm");
form.addEventListener("submit", async function (event) {
  event.preventDefault();

  const name = document.getElementById("name-input").value.trim();
  const hiddenInputs = form.querySelectorAll("input[type='hidden']");
  const selectedAnswers = [];

  hiddenInputs.forEach((input) => {
    if (input.value.trim()) {
      selectedAnswers.push(`- ${input.name} ${input.value}`);
    }
  });

  if (selectedAnswers.length === 0) {
    alert("Please answer at least one question before submitting.");
    return;
  }

  const prompt = `
Suggest a real-world perfume based on the following preferences:
${selectedAnswers.join("\n")}

Return the result as a JSON object with the following keys:
- "Fragrance Name"
- "Fragrance description EN" (do not mention the fragrance name).
- "Fragrance description AR" (do not mention the fragrance name).
- "Feelings description EN" (do not mention the fragrance name).
- "Feelings description AR" (do not mention the fragrance name).
- "Components": an object with the following keys:
    - "Top Notes"
    - "Middle Notes"
    - "Base Notes"

Each note group ("Top Notes", "Middle Notes", "Base Notes") should be an array of objects with this structure:
{
  "name_en": string,     // Ingredient name in English
  "name_ar": string,     // Ingredient name in Arabic
  "percentage": number   // Percentage of total composition (all notes combined must sum to 100)
}

Return the JSON using double quotes for all keys and string values, as required by the JSON standard, without using any backticks or code blocks:
Ensure the percentages are normalized to exactly 100% in total across all notes.
Return only the JSON object, nothing else.
`.trim();

  console.log("Generated Prompt:\n", prompt);

  try {
    showLoading(); // Show the spinner

    const result = JSON.parse(await AskAI(prompt)); // Your AI function
    console.log("AI Response:", result);

    // Hide form and progress bar
    document.getElementById("myForm").style.display = "none";
    document.querySelector(".progress").style.display = "none";
    // Show result section
    document.getElementById("resultsSection").style.display = "block";
    requestAnimationFrame(() =>
      document.getElementById("resultsSection").classList.add("show")
    );

    // Showing the AI result
    aiResponse = result;
    await renderEnglishContent(aiResponse);
  } catch (error) {
    console.error("Error during AI call:", error);
    alert("Something went wrong with the AI. Probably your aura confused it.");
  } finally {
    hideLoading(); // Hide the loading no matter what
  }
});

function showLoading() {
  document.getElementById("loadingOverlay").classList.remove("d-none");
}

function hideLoading() {
  document.getElementById("loadingOverlay").classList.add("d-none");
}

document.querySelectorAll(".reset-form-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    // 1. Reset the form fields
    const form = document.getElementById("myForm");
    if (form) {
      form.reset();
    }

    // 2. Reset hidden input values (e.g. AI hidden perfume name)
    const hiddenProps = form.querySelectorAll('[name^="properties["]');
    hiddenProps.forEach((input) => (input.value = ""));

    // 3. Reset selections (remove selected class from buttons)
    document
      .querySelectorAll(".option-btn.selected")
      .forEach((btn) => btn.classList.remove("selected"));

    // 4. Show the form again
    form.style.display = "block";

    // 5. Hide results section
    const results = document.querySelector(".match-reveal-container");
    if (results) {
      results.style.display = "none";
    }

    // 6. Reset questions to first
    const questions = document.querySelectorAll(".question");
    questions.forEach((q) => q.classList.remove("active"));
    if (questions[0]) questions[0].classList.add("active");
    currentQuestion = 0;

    // 7. Reset progress bar
    const progressBar = document.getElementById("formProgress");
    if (progressBar) {
      progressBar.style.width = "0%";
      progressBar.setAttribute("aria-valuenow", "0");
    }

    // 8. Hide submit button
    document.getElementById("submit-btn").classList.add("d-none");

    // 9. Hide featured prouct
    $(".section-featured-product").hide();
  });
});
